<template>
    <div>
        <v-dialog 
            v-model="expediteDialog" 
            persistent
            width="55%"
            elevation="8">
            <v-card>
                <v-card-title class="headline primary darken-2 white--text d-flex justify-space-between">
                    Expedite My Project
                    <v-btn
                        icon
                        @click="expediteDialog = false">
                        <v-icon 
                            class="white--text">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="py-6 align-center mx-auto text-subtitle-1">
                    <div class="d-block">The cost for expediting this project is: <strong>${{ moduleInfo.expedited_cost }}</strong></div>
                    <div class="d-block">Once submitted and accepted, you will receive <u><i>priority</i></u> scheduling and the new estimated delivery timeline for this project will be <strong>{{ moduleInfo.expedited_days_to_complete }} business days</strong> after receipt of full information.</div>
                    <div class="d-block mt-6">Please review terms and conditions for more information: Expedite Terms and Conditions (<strong><a @click="showTandC = !showTandC">here</a></strong>)</div>
                    <div v-if="showTandC" class="d-block mt-3 mb-7 mx-7">
                        <div class="d-block text-h6">Expedite Terms and Conditions:</div>
                        <div class="d-block">The expedite option timeline is subject to the following:</div>
                        <ul style="">
                            <li>Receipt of full information</li>
                            <li>Client availability</li>
                            <li>Client decisiveness and response time</li>
                            <li>Third-party response or processing time, if applicable.</li>
                            <li>To ensure the project is completed per your requested date, certain phone calls may be condensed and/or eliminated.</li>
                        </ul>
                        <div class="d-block">Business days is defined as Monday - Friday, subject to company closures. Currently, SRG is closed for all major Federal holidays in addition to the week of Christmas Eve and New Year's Day.</div>
                    </div>
                    <!-- <div class="d-block" v-html="moduleInfo.status == 'open' ? `If accepted, the new estimated delivery timeline for this project will be <strong> ${moduleInfo.expedited_days_to_complete} business days</strong> after submitting this request, subject to receipt of full information, client availability, client response time, and third-party response or processing time, if applicable.` : `If accepted, the new estimated delivery date for this project will be <strong>${formatDate(addBusinessDaysExpedited(moduleInfo.expedited_days_to_complete), 'mmm. dd, yyyy')}</strong>`"></div> -->
                    <div class="d-block"><strong>By clicking the confirm button below you are accepting the charges to have the project expedited.</strong></div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn 
                        outlined
						color="error"
						@click="expediteDialog = false">
						Cancel
					</v-btn>
                    <v-btn 
                        v-if="!expediteProcessing"
						color="primary"
                        class="ml-6"
						@click="confirmExpedite">
						Confirm
					</v-btn>
                    <v-btn 
                        v-else
                        outlined
						color="primary"
                        class="ml-6 px-2">
                        <v-progress-circular
                            :width="2"
                            :size="26"   
                            indeterminate
                            class="mx-6"
                            color="primary">
                        </v-progress-circular>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
        <v-card v-if="moduleInfo.module_key != 'entity-maintenance-program'" elevation="2" 
                class="py-0 mt-5 mb-4 flex-grow-1"
                style="border-top: 6px solid #00818E">
            <div class="py-1 mx-9 align-center justify-center">
                <a @click="expediteDialog = true" class="status_project_title d-flex justify-center align-center">
                    <div class="d-inline">Expedite My Project</div>
                    <ExpediteTruck truckColor="secondary" style="width: 46px" class="ml-3" /> <!-- primary -->
                </a>
            </div>
        </v-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import appUrls from '../helpers/environment'
    import dateFormat, { masks } from "dateformat";
    import Cookie from 'js-cookie'

    export default {
        name: 'ExpediteProject',

        props: {
            moduleInfo: Object,
            getCurrentProject: Function
        },

        data () {
            return {
                showTandC: false,
                expediteDialog: false,
                expediteProcessing: false,
                now_time: Math.floor(new Date().getTime() / 1000),
                exsisting_close_date_time: Math.floor(new Date(this.moduleInfo.close_date).getTime() / 1000)
            }
        },

        methods: {
            formatDate: function ( date, mask ) {
                if ( date == null ) return `N/A`

                return dateFormat(date.substr(0,10)+' 00:00:00', mask)
            },

            confirmExpedite: async function () {
                // console.log(this.moduleInfo)
                try {
                    this.expediteProcessing = true
                    const new_ecd = this.moduleInfo.status != 'open' ? this.addBusinessDaysExpedited(this.moduleInfo.expedited_days_to_complete) : ''

                    const confirm_expedite = await axios.put(`${appUrls.api}/api/project_expedite`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project: this.moduleInfo,
                        ecd: new_ecd
                    })

                    if ( confirm_expedite.data.outcome ) {
                        this.$emit('getCurrentProject')
                        setTimeout(() => {
                            this.expediteProcessing = false
                            this.expediteDialog = false
                        }, 1000);
                    }

                } catch ( error ) {
                    console.log(error);
                }                
            },

            addBusinessDaysExpedited: function (daysToAdd) {
                const currentDate = new Date;

                for (let i = 1; i <= daysToAdd; i++) {
                    currentDate.setDate(currentDate.getDate() + 1);
                    if (currentDate.getDay() === 6) {
                        currentDate.setDate(currentDate.getDate() + 2);
                    } else if (currentDate.getDay() === 0) {
                        currentDate.setDate(currentDate.getDate() + 1);
                    }
                }
                
                const calcDate = currentDate.toISOString().substring(0,10)
                return calcDate
            },

            addCalendarDaysExpedited: function (daysToAdd) {
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate() + daysToAdd);
                
                const calcDate = currentDate.toISOString().substring(0,10)
                return calcDate
            }
        }
    }
</script>

<style scoped>
    a.status_project_title {
        font-family: 'Sansation';
        font-size: 1.12rem !important;
        text-decoration: none;
        color: #5F6062;
    }
    a.status_project_title:hover  {
        /* color: #0096A6; */
        color: #97C131;
    }
</style>


// WEBPACK FOOTER //
// src/components/ExpediteProject.vue